import ReportPreview from './ReportPreview';

export default ReportPreview;
